import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

const LinkButtonStyled = styled.div.attrs()`
  ${props => {
    const { secondary } = props;
    return css`
      background-color: ${secondary ? '#000' : '#FFF'};
      width: fit-content;
      border-radius: 3px;

      a {
        display: block;
        padding: 15px 32px;
        text-decoration: none;
        color: ${secondary ? '#FFF' : '#000'};
        font: 700 13px/13px 'CentraNo2', sans-serif;
        letter-spacing: 1.52px;
        text-transform: uppercase;
      }
    `;
  }};
`;

const LinkButton = ({ children, href, ...props }) => (
  <LinkButtonStyled className={props?.className || 'link-button'} {...props}>
    <a href={href}>{children}</a>
  </LinkButtonStyled>
);

LinkButton.defaultProps = {
  children: undefined,
  secondary: undefined
};

LinkButton.propTypes = {
  children: PropTypes.node,
  href: PropTypes.string.isRequired,
  secondary: PropTypes.bool
};

export default LinkButton;
